/**
 * URLs de recursos del portal de datos abiertos del Cabildo de Tenerife
 * Base URL: https://datos.tenerife.es/ckan
 */

export const CKAN_BASE = 'https://datos.tenerife.es/ckan';

// IDs de datasets
export const DATASET_IDS = {
  PRECIOS_2026: '125d34ce-bd0f-423a-9242-b15f826a6750',
  PRECIOS_2025: '6ef31279-7dd5-4c19-ad77-d5defe92b46e',
  PRECIOS_2024: '0723d38b-dbea-4d58-b864-6943c972b2e0',
  COMARCAS_VINA: 'cf6935e2-9c5c-42b8-bb6c-651c20463a26',
  COMARCAS_PAPA: '50616742-c3e1-4928-9cc2-4a97f167fff7',
  AVISOS_VINA: '175e6d1b-f5e3-4cfa-b650-bccaaad729c2',
  AVISOS_PAPA: 'fc109b0c-8af2-44d3-bf3b-c18bcc53f850',
  FORMACION: 'actividades-formativas-de-agrocabildo',
  COMERCIOS: 'comercios-en-el-ambito-de-la-agricultura-en-tenerife',
};

// Configuración de precios por año y mes
export const PRECIOS_CONFIG = {
  2026: {
    datasetId: '125d34ce-bd0f-423a-9242-b15f826a6750',
    meses: {
      2: { resourceId: 'ae085e03-ad66-4927-9b80-03bf6eee761b', nombre: 'febrero' },
      1: { resourceId: 'aab47f41-3052-489f-8392-7acf4cb7e850', nombre: 'enero' },
    }
  },
  2025: {
    datasetId: '6ef31279-7dd5-4c19-ad77-d5defe92b46e',
    meses: {
      12: { resourceId: '4422a144-d736-4101-b6eb-4c8fd607ba4a', nombre: 'diciembre' },
      11: { resourceId: '343e5113-3a38-499c-89cc-6a1616281272', nombre: 'noviembre' },
      10: { resourceId: '627fda95-fe9c-4eb6-843d-2d728ae62435', nombre: 'octubre' },
      9: { resourceId: '12c8fd5a-869e-4958-b822-a6a5fd96d93a', nombre: 'septiembre' },
      8: { resourceId: '68999a01-fa24-4988-927f-471e3c2ee566', nombre: 'agosto' },
      7: { resourceId: '40f9373a-a4f8-4aeb-8a22-468637c02f6d', nombre: 'julio' },
      6: { resourceId: '191af8fc-870e-4391-8178-1a96c6db9541', nombre: 'junio' },
      5: { resourceId: '1dbcd704-5168-4cd5-8f82-5d87398c7022', nombre: 'mayo' },
      4: { resourceId: '3c9fe8e0-ea72-4687-a6d9-422fd1593158', nombre: 'abril' },
      3: { resourceId: '36be5f0f-c670-417b-ac47-3a28cb93bd65', nombre: 'marzo' },
      2: { resourceId: '97021233-4934-46a3-9cb2-9de918033422', nombre: 'febrero' },
      1: { resourceId: '715cbd1a-f765-4fd2-bbe1-ce9cabe6cf18', nombre: 'enero' },
    }
  },
  2024: {
    datasetId: '0723d38b-dbea-4d58-b864-6943c972b2e0',
    meses: {
      12: { resourceId: 'a83b38f2-f6ae-4749-b14f-1b07c59c5e9e', nombre: 'diciembre' },
      11: { resourceId: '569e3e83-d957-40f6-9d39-a6e46931f932', nombre: 'noviembre' },
      10: { resourceId: '25dacb3b-8733-4199-a875-0942e7334179', nombre: 'octubre' },
      9: { resourceId: '2b94813e-d34b-4a80-88f2-fe834f94c230', nombre: 'septiembre' },
      8: { resourceId: '52b256ed-57a0-41ba-8bd4-450ba841fc73', nombre: 'agosto' },
      7: { resourceId: '231fb5c2-2723-47b4-9c28-4aca44a0011f', nombre: 'julio' },
      6: { resourceId: '5dbc8229-c67e-46ba-951e-11626484fdd6', nombre: 'junio' },
    }
  }
};

// Función para obtener URL de precios
export function getPreciosUrl(year, month) {
  const config = PRECIOS_CONFIG[year];
  if (!config) return null;
  
  const mesConfig = config.meses[month];
  if (!mesConfig) return null;
  
  return `${CKAN_BASE}/dataset/${config.datasetId}/resource/${mesConfig.resourceId}/download/precios-diarios-de-${mesConfig.nombre}-de-${year}.json`;
}

// URLs directas de recursos (para descarga directa sin proxy)
export const RESOURCE_URLS = {
  // Precios Mercatenerife 2026
  PRECIOS_ENERO_2026: `${CKAN_BASE}/dataset/${DATASET_IDS.PRECIOS_2026}/resource/aab47f41-3052-489f-8392-7acf4cb7e850/download/precios-diarios-de-enero-de-2026.json`,
  
  // GeoJSON de Comarcas
  GEOJSON_COMARCAS_VINA: `${CKAN_BASE}/dataset/${DATASET_IDS.COMARCAS_VINA}/resource/546a0f68-81e3-49fb-8fd4-33e4a4f73b00/download/comarcas-de-cultivos-de-la-vina.geojson`,
  GEOJSON_COMARCAS_PAPA: `${CKAN_BASE}/dataset/${DATASET_IDS.COMARCAS_PAPA}/resource/a5bf71ba-5669-4a38-83b1-5bce3f8da21b/download/comarcas-de-cultivos-de-la-papa.geojson`,
  
  // Avisos Fitosanitarios Viña
  AVISOS_VINA_BOTRYTIS: `${CKAN_BASE}/dataset/${DATASET_IDS.AVISOS_VINA}/resource/c20edc57-6e26-4721-8b39-d251a7ca5dea/download/avisos-fitosanitarios-del-cultivo-de-vina-de-riesgo-de-botrytis.json`,
  AVISOS_VINA_MILDIU: `${CKAN_BASE}/dataset/${DATASET_IDS.AVISOS_VINA}/resource/d8c6f2ee-d890-4f93-8b3f-a912eacfb4dd/download/avisos-fitosanitarios-del-cultivo-de-vina-de-riesgo-de-mildiu.json`,
  AVISOS_VINA_OIDIO: `${CKAN_BASE}/dataset/${DATASET_IDS.AVISOS_VINA}/resource/f1ecf563-042d-4037-a666-efb6c383f918/download/avisos-fitosanitarios-del-cultivo-de-vina-de-riesgo-de-oidio.json`,
  
  // Avisos Fitosanitarios Papa
  AVISOS_PAPA_MILDIU: `${CKAN_BASE}/dataset/${DATASET_IDS.AVISOS_PAPA}/resource/c68b586b-d78c-4101-912c-f39943da2e5f/download/avisos-fitosanitarios-del-cultivo-de-papa-de-riesgo-de-mildiu.json`,
};

// Mapeo de niveles de aviso a valores numéricos para colores
export const NIVEL_AVISO_MAP = {
  'SIN ALERTA': 0,
  'BAJO': 1,
  'MEDIO': 2,
  'ALTO': 3,
};

// Colores por nivel de aviso
export const NIVEL_AVISO_COLORS = {
  0: '#E2E4DF', // Sin alerta - Gris
  1: '#4A7C59', // Bajo - Verde
  2: '#E9C46A', // Medio - Amarillo
  3: '#BC4749', // Alto - Rojo
};

export default {
  CKAN_BASE,
  DATASET_IDS,
  RESOURCE_URLS,
  NIVEL_AVISO_MAP,
  NIVEL_AVISO_COLORS,
};
